import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {store} from "./redux/storeConfig/store";

import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import config from "./config";

const stripePromise = loadStripe(config.STRIPE_PK);

ReactDOM.render(
	<React.StrictMode>
		<Provider store={store}>
			<Elements stripe={stripePromise}>
				<App/>
			</Elements>
		</Provider>
	</React.StrictMode>,
	document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
